import merge from 'lodash.merge'
import kpi from '@/utils/kpi'

/**
 * Logs the given KPI event.
 */
export default function logKpiResult({ resource, operation, state, correlationId, data }) {
  const kpiPayload = {
    resource,
    operation,
    state,
    correlationId,
    data: merge({}, data)
  }

  kpi.track(kpiPayload)
}
